import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import HashSet from '../../../../java/util/HashSet';
import CoordinateFilter from '../geom/CoordinateFilter';
import ArrayList from '../../../../java/util/ArrayList';
var UniqueCoordinateArrayFilter = /*#__PURE__*/function () {
  function UniqueCoordinateArrayFilter() {
    _classCallCheck(this, UniqueCoordinateArrayFilter);
    UniqueCoordinateArrayFilter.constructor_.apply(this, arguments);
  }
  _createClass(UniqueCoordinateArrayFilter, [{
    key: "filter",
    value: function filter(coord) {
      if (this._coordSet.add(coord)) this._list.add(coord);
    }
  }, {
    key: "getCoordinates",
    value: function getCoordinates() {
      var coordinates = new Array(this._list.size()).fill(null);
      return this._list.toArray(coordinates);
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [CoordinateFilter];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._coordSet = new HashSet();
      this._list = new ArrayList();
    }
  }, {
    key: "filterCoordinates",
    value: function filterCoordinates(coords) {
      var filter = new UniqueCoordinateArrayFilter();
      for (var i = 0; i < coords.length; i++) filter.filter(coords[i]);
      return filter.getCoordinates();
    }
  }]);
  return UniqueCoordinateArrayFilter;
}();
export { UniqueCoordinateArrayFilter as default };